import React, { useState } from "react";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { gql, useMutation } from '@apollo/client';

const SEND_SALE_EMAIL = gql`
        mutation SendSaleEmail($email: String!
          $name: String!
          $message: String!){
        sendSaleEmail(
          email: $email
          name: $name
          message: $message
          )
        }`;
function SalesContact() {
 
  const [sendSaleEmail, {loading, error}] = useMutation(SEND_SALE_EMAIL);
  const [formData, setFormData] = useState({ name: "", email: "",message: "" });
  const [status, setStatus] = useState(""); // Track form submission status
  const [validated, setValidated] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {

    const form = e.currentTarget;
    const { name, email, message } = formData;
    e.preventDefault();

    if (form.checkValidity() !== false) {
      e.stopPropagation();
      try {
        
        sendSaleEmail({ variables: { email, name, message }});
        if(loading) return setStatus("Enviando...");
        if (error) return setStatus(`Ocurrio un error. Por favor intentelo mas tarde ${error}`);

        setStatus("Mensaje enviado correctamente! Muchas Gracias por su mensaje.");
        setFormData({ name: "", email: "",message: "" }); // Clear the form
        return;

      } catch (error) {
        console.error("Error enviando el mensaje", error);
        setStatus("Ocurrio un error. Por favor intentelo mas tarde.");
      }
    }
    setValidated(true);

  };
    return (
        <Card className="project-card-view">
          <Card.Body>
            <Card.Title>
              <strong className="purple"></strong>
            </Card.Title>
            <Card.Subtitle className="mb-2">
              <strong className="purple">Completa este formulario y enseguida nos pondremos en contacto contigo</strong>
            </Card.Subtitle>
            <Card.Text style={{ textAlign: "justify" }}>
              Comienza a trabajar con CONTPAQi®
            </Card.Text>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="formName">
                <Form.Label style={{float: "left"}}>Nombre*</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
                 <Form.Control.Feedback type="invalid">
                  Por favor escriba su Nombre.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label style={{float: "left"}}>Email*</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Por favor escriba su Email.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3" controlId="formMessage">
                <Form.Label style={{float: "left"}} >¿Producto de tu interés?</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Escribe tu mensaje"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Por favor escriba su mensaje.
                </Form.Control.Feedback>
              </Form.Group>
              <Button variant="secondary" type="submit">
                Enviar Mensaje
              </Button>
              {status && <p style={{ marginTop: "10px", color: "white" }}>{status}</p>}
            </Form>
          </Card.Body>
        </Card>
      );
}

export default SalesContact;